import './replacement.component.scss'

const replacementCards = document.querySelectorAll('.replacement-card')

if (replacementCards.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const element = entry.target
      if (entry.isIntersecting) {
        if (!element.classList.contains('active')) {
          const elementVideo = element.querySelector('.replacement-card__video')
          const dataSrc = elementVideo.dataset.src
          const videoTag = document.createElement('video')
          videoTag.src = dataSrc
          videoTag.autoplay = true
          videoTag.loop = true
          videoTag.muted = true
          videoTag.playsInline = true
          elementVideo.append(videoTag)
          element.classList.add('active')
          videoTag.play()
        } else {
          const videoTag = element.querySelector('video')
          
          if (videoTag) {
            videoTag.play()
          }
        }
      } else {
        const videoTag = element.querySelector('video')

        if (videoTag) {
          videoTag.pause()
        }
      }
    })
  }, {
    rootMargin: '10% 0px 10% 0px'
  })
  replacementCards.forEach(card => {
    const isVideoCard = card.classList.contains('replacement-card_with-video')
    if (isVideoCard) {
      observer.observe(card)
    }
  })
}